import React, { ReactNode } from 'react';

import styled from 'styled-components';

import Header from 'common/Header';

import RecommendationCompanyBreadcrumb from './RecommendationCompanyBreadcrumb';

const IconContainer = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  margin-right: 10px;
  padding: 1px;
  background-image:
    linear-gradient(var(--white), var(--white)),
    linear-gradient(to bottom, var(--competitor-purple), var(--negative-orange) 50%, var(--flamingo-pink));
  background-origin: border-box;
  background-clip: content-box, border-box;
`;

const AICIHeader = ({ children }: { children?: ReactNode }) => (
  <Header
    title="AI Competitive Intelligence"
    breadcrumbs={<RecommendationCompanyBreadcrumb />}
    iconComponent={
      <IconContainer>
        <img src="/icons/ai-blob.svg" alt="ai-blob" height="30px" width="30px" />
      </IconContainer>
    }
  >
    {children}
  </Header>
);

export default AICIHeader;
